import afZA from './mui-locales/af-za';
import enUS from './mui-locales/en-us';
import enZA from './mui-locales/en-za';

const locales = { enUS, enZA, afZA };

export default locales;
